module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAUVBMVEUAAADR0dHQ0NDR0dHR0dHU1NTy8vLR0dHR0dHS0tLR0dHR0dHR0dHQ0NDS0tLV1dXT09PQ0NDQ0NDR0dHS0tLQ0NDS0tLT09PR0dHW1tbQ0NCv7DUhAAAAGnRSTlMAoH7ycAsE24kU7eOomDkvIuXKyIBoZlFCGWgVVQAAAABrSURBVBjTnc43FgJBEANRTY9fjwfd/6DQ8NhE2Vb4lQh7zwekPMSXYCIb/vUVXjmRscNbO2a2AuDOT+Zr44xAXjaU6jhkbGcyODLervwWUuQPpUM4joo15ypogAkmIAlOwCRIs4M/FZcgLW+BKxkxuwvPRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/VIP 2.png
// module id = 1115
// module chunks = 5